import React, { useState, useEffect } from 'react';
import { 
  Card, Statistic, Row, Col, Table, Typography, 
  Button, message, Tag 
} from 'antd';
import {
  TeamOutlined, CheckCircleOutlined,
  CloseCircleOutlined, CrownOutlined,
  HistoryOutlined, SettingOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/request';

const { Title, Text } = Typography;

const AdminDashboard = () => {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('=== AdminDashboard 组件加载 ===');
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    console.log('=== 开始获取统计信息 ===');
    try {
      const token = localStorage.getItem('admin_token');
      console.log('使用token:', token ? '存在' : '不存在');
      
      console.log('发送请求到: /admin/statistics');
      const response = await request.get('/admin/statistics', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('统计信息响应:', response);
      
      if (response.success) {
        console.log('统计数据获取成功:', response.data);
        setStatistics(response.data);
      } else {
        console.log('统计数据获取失败:', response.message);
      }
    } catch (error) {
      console.error('获取统计信息失败:', error);
      // 即使API失败，也要显示界面
      setStatistics({
        user_statistics: {
          total_users: 0,
          active_users: 0,
          inactive_users: 0,
          admin_users: 0
        },
        recent_users: []
      });
    } finally {
      console.log('设置loading为false');
      setLoading(false);
    }
  };

  const recentUsersColumns = [
    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
      render: (text) => <Text strong>{text}</Text>
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: '注册时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => new Date(text).toLocaleString()
    },
  ];

  console.log('AdminDashboard渲染，loading:', loading, 'statistics:', statistics);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        fontSize: '18px',
        color: '#1890ff'
      }}>
        <div>正在加载管理员仪表盘...</div>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', background: '#f0f2f5', minHeight: '100vh' }}>
      <Title level={2} style={{ marginBottom: '24px', color: '#1890ff' }}>
        🎉 管理员仪表盘 - 加载成功！
      </Title>
      
      <div style={{ marginBottom: '24px', padding: '16px', background: '#e6f7ff', borderRadius: '8px' }}>
        <Text strong style={{ color: '#1890ff' }}>
          恭喜！您已成功登录管理员后台系统！
        </Text>
      </div>
      
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总用户数"
              value={statistics?.user_statistics?.total_users || 0}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="活跃用户"
              value={statistics?.user_statistics?.active_users || 0}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="停用用户"
              value={statistics?.user_statistics?.inactive_users || 0}
              prefix={<CloseCircleOutlined />}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="管理员"
              value={statistics?.user_statistics?.admin_users || 0}
              prefix={<CrownOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 快速入口 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card 
            hoverable
            onClick={() => navigate('/admin/users')}
            style={{ textAlign: 'center', cursor: 'pointer' }}
          >
            <TeamOutlined style={{ fontSize: '32px', color: '#1890ff', marginBottom: '8px' }} />
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>用户管理</div>
          </Card>
        </Col>
        <Col span={8}>
          <Card 
            hoverable
            onClick={() => navigate('/admin/processing-history')}
            style={{ textAlign: 'center', cursor: 'pointer' }}
          >
            <HistoryOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '8px' }} />
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>处理历史</div>
          </Card>
        </Col>
        <Col span={8}>
          <Card 
            hoverable
            onClick={() => navigate('/admin/settings')}
            style={{ textAlign: 'center', cursor: 'pointer' }}
          >
            <SettingOutlined style={{ fontSize: '32px', color: '#722ed1', marginBottom: '8px' }} />
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>系统设置</div>
          </Card>
        </Col>
      </Row>

      {/* 最近注册用户 */}
      <Card 
        title="最近注册用户" 
        extra={
          <Button 
            type="primary" 
            onClick={() => navigate('/admin/users')}
          >
            查看全部
          </Button>
        }
      >
        <Table
          columns={recentUsersColumns}
          dataSource={statistics?.recent_users || []}
          rowKey="id"
          pagination={false}
          size="small"
          locale={{ emptyText: '暂无用户数据' }}
        />
      </Card>
    </div>
  );
};

export default AdminDashboard;